// @flow

import * as React from 'react';

import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';

type Props = {
  icon: React.Node,
  options?: React.Node,
  children?: React.Node
};

type State = {
  anchorEl: ?HTMLButtonElement
};

export default class IconMenu extends React.Component<Props, State> {
  state = {
    anchorEl: null
  };

  handleClick = (event: SyntheticEvent<HTMLButtonElement>) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;
    const { icon, options, children, ...props } = this.props;
    return (
      <React.Fragment>
        <IconButton
          color="inherit"
          className="icon-button"
          aria-label="More"
          aria-controls={anchorEl ? 'nav-icon-menu' : undefined}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          {icon}
        </IconButton>
        <Menu
          id="nav-icon-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          {...props}
        >
          {React.Children.map(options || children, (option?: React.Node) => {
            return (
              option &&
              React.cloneElement(option, {
                onClick: option.props.onClick
                  ? (ev: SyntheticEvent<HTMLButtonElement>) => {
                      this.handleClose();
                      option.props.onClick(ev);
                    }
                  : this.handleClose
              })
            );
          })}
        </Menu>
      </React.Fragment>
    );
  }
}